export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7817.4a8cf78c.jpg";